import { Badge } from "react-bootstrap";
import UpdateListing from "../../Components/Listing/UpdateListing";
import ShowStatus from "../../Components/Listing/ShowStatus";

const All = [
  {
    id: 1,
    name: "The Lodge",
    host_name: "Vikas Sharma",
    listing_type: "Private Home Rooms",
    max_capacity: 5,
    created_on: "10/3/2024",
    updated_by: "Admin 1",
    updated_on: "10/3/2024",
    status: (
      <Badge
        pill
        bg="warning"
        text="white"
        style={{ width: "100px", fontSize: "13px" }}
      >
        Pending
      </Badge>
    ),
    action: (
      <button
        className="btn-square btn mx-2"
        style={{ backgroundColor: "#A020F0" }}
      >
        <i
          className="icon-reload"
          style={{ color: "white", fontSize: "17px", marginTop: "2px" }}
        ></i>
      </button>
    ),
  },
  {
    id: 2,
    name: "Maya Shri Guest House",
    host_name: "Rakesh",
    listing_type: "Private Home Rooms",
    max_capacity: 5,
    created_on: "10/3/2024",
    updated_by: "Admin 1",
    updated_on: "10/3/2024",
    status: (
      <Badge
        pill
        bg="success"
        text="white"
        style={{ width: "100px", fontSize: "13px" }}
      >
        Active
      </Badge>
    ),
    action: (
      <button
        className="btn-square btn mx-2"
        style={{ backgroundColor: "#A020F0" }}
      >
        <i className="icon-reload" style={{ color: "white" }}></i>
      </button>
    ),
  },
  {
    id: 3,
    name: "Varsha Home Stay",
    host_name: "Bhushan",
    listing_type: "Private Home Rooms",
    max_capacity: 5,
    created_on: "10/3/2024",
    updated_by: "Admin 1",
    updated_on: "10/3/2024",
    status: (
      <Badge
        pill
        bg="danger"
        text="white"
        style={{ width: "100px", fontSize: "13px" }}
      >
        Deactivate
      </Badge>
    ),
    action: (
      <button
        className="btn-square btn mx-2"
        style={{ backgroundColor: "#A020F0" }}
      >
        <i className="icon-reload" style={{ color: "white" }}></i>
      </button>
    ),
  },
];

export const tableColumns = [
  {
    name: "Listing ID",
    selector: (row) => row.listing_id,
    sortable: true,
    center: true,
  },
  {
    name: "Listing Name",
    selector: (row) => row.listing_name,
    cell: (row) => (
      <div style={{ textAlign: "center" }}>
        <UpdateListing data={row} name={row.listing_name} />
      </div>
    ),
    // cell: (row) => <UpdateListing data={row} name={row.listing_name} />,
    sortable: true,
    center: true,
  },
  {
    name: "Volunteer Name",
    selector: (row) => row.user_name,
    sortable: true,
    center: true,
  },
  {
    name: "Listing Type",
    selector: (row) => row.accomodation_type,
    sortable: true,
    center: true,
  },
  {
    name: "Created On",
    selector: (row) => row.created_on,
    sortable: true,
    center: true,
  },
  {
    name: "Updated By",
    selector: (row) => row.modified_by,
    sortable: true,
    center: true,
  },
  {
    name: "Updated On",
    selector: (row) => row.modified_on,
    sortable: true,
    center: true,
  },
  {
    name: "Status",
    cell: (row) => <ShowStatus data={row} />,
    sortable: true,
    center: true,
  },
  {
    name: "Action",
    cell: (row) => <UpdateListing data={row} />,
    center: true,
  },
];

export default All;
